import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import config from '../config';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import chatService from '../services/chat.service';
import { toast } from 'react-toastify';
import SendGiftsModal from '../components/gifts/SendGiftsModal';
import { apiGifts } from '../api/apiGifts.api';

import { ProfileExample } from '../components/profile/ProfileExample';

function Profile() {
  const params = useParams();

  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [isOpenPresentShop, setIsOpenPresentShop] = useState(false);

  const fetchUserProfile = async () => {
    try {
      const response = await axiosPrivate.get(`${config.API.USERS.BASE}/${params.id}`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  const onOpenChat = async () => {
    try {
      const res = await apiGifts.hasSentGift(axiosPrivate, params.id);
      if (res.data.data.hasSend) {
        await handleToFindOrCreateChat();
      } else {
        setIsOpenPresentShop(true);
      }
    } catch (error) {
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  const onSendGiftToStartChatting = async (giftId) => {
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId: params.id, giftId: giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Profile] Error sending gift:', error);
      toast.error(error.response.data.message || 'Ошибка отправки подарка');
    }
  };

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userData._id);
      console.log('[Profile]', res);
      navigate(`/chats/${res.data._id}`);
    } catch (error) {
      console.error('[Profile] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <>
      <SendGiftsModal
        isOpen={isOpenPresentShop}
        onClose={() => setIsOpenPresentShop(false)}
        renderTitle={() => (
          <h2 className="text-[18px] font-semibold text-white text-center leading-[1.5] font-raleway">
            Обозначь себя, сделав человеку приятно. Это шаг к новым знакомствам!
          </h2>
        )}
        onSend={onSendGiftToStartChatting}
      />
      <ProfileExample
        userId={params.id}
        actionButtons={
          <>
            <button className="size-[58px] flex items-center justify-center rounded-full border-[2px] border-white bg-black/30">
              <img src="/icons/heart.svg" alt="heart" />
            </button>
            <button
              onClick={onOpenChat}
              className="size-[58px] flex items-center justify-center rounded-full border-[2px] border-white bg-black/30"
            >
              <img src="/icons/chat.svg" alt="chat" />
            </button>
          </>
        }
      />
    </>
  );
}

export default Profile;
